// Admin API client — /admin/blog/* (mirrors the API's blog aggregate).

import type {
  BlogPost,
  BlogCreateRequest,
  BlogUpdateRequest,
  BlogRevision,
  Author,
  AuthorCreateRequest,
  AuthorUpdateRequest,
  AuthorListResponse,
} from '@a7y/types';
import { client } from './transport';
import { blogMutate, contentSectionApi } from './content-transport';

export const blogApi = {
  // ------------------------------------------------------------------------------------
  // Blog CMS (A7Y-2068). Paths are relative to the console's `/admin` baseUrl and
  // nested under `/blog` (the admin_blog_route sub-router). Built on the shared
  // `contentSectionApi` factory (A7Y-4470 C5) plus the blog-only author registry.
  blog: {
    ...contentSectionApi<BlogPost, BlogCreateRequest, BlogUpdateRequest, BlogRevision>('/blog'),

    // --- Author registry (A7Y-4474) ---
    authors: {
      list: () => client.get<AuthorListResponse>('/blog/authors'),
      create: (data: AuthorCreateRequest) => blogMutate<Author>('/blog/authors', 'POST', data),
      update: (id: string, data: AuthorUpdateRequest) =>
        blogMutate<Author>(`/blog/authors/${id}`, 'PATCH', data),
      remove: (id: string) => blogMutate<{ success: true }>(`/blog/authors/${id}`, 'DELETE'),
    },
  },
};
